import { createSelector } from 'reselect';
const singleProductTileProductSelector = (state, props) => {
    const { productCode, colourId } = props.initializationProduct;
    return state.singleProductsList.find((product) => product.productCode === productCode && product.colourId === colourId);
};
export const makeGetSingleProductTileProduct = () => createSelector([singleProductTileProductSelector], (product) => product);
